// ABOUTME: How each assignment target (owner, dealership, client) is shown: its icon and its label.
// ABOUTME: One source for the assignment chips, the dealership line of the catalogue and cart, and any other view.

import { GroupOutlinedIcon, PersonOutlinedIcon, StorefrontOutlinedIcon } from '@ds/coolshop';
import { defineMessages } from 'react-intl';

import type { AssignTarget } from '../api/assignmentApi';

/** The targets in the order they are shown (the assignment chips). */
export const ASSIGNMENT_TARGETS: readonly AssignTarget[] = ['owner', 'dealership', 'client'];

/** The target's icon, rendered by the caller at its own size. */
export const ASSIGNMENT_TARGET_ICONS: Record<AssignTarget, typeof PersonOutlinedIcon> = {
    owner: PersonOutlinedIcon,
    dealership: StorefrontOutlinedIcon,
    client: GroupOutlinedIcon,
};

/** The target's label, as in "Dealership: ACE Industries". */
export const ASSIGNMENT_TARGET_LABELS = defineMessages<AssignTarget>({
    owner: { id: 'nodeAssignment.owner-label', defaultMessage: 'Owner' },
    dealership: { id: 'nodeAssignment.dealership-label', defaultMessage: 'Dealership' },
    client: { id: 'nodeAssignment.client-label', defaultMessage: 'Client' },
});
